import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipIfTruncatedDirective } from './directives/tooltip-if-truncated.directive';
import { HasPermissionDirective } from './directives/has-permission.directive';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NxtDropdownComponent } from './components/nxt-dropdown/nxt-dropdown.component';
import { NxtDropdownLabelSuffixDirective } from './components/nxt-dropdown/nxt-dropdown-label-suffix.directive';
import { NxtDropdownTriggerComponent } from './components/nxt-dropdown/components/nxt-dropdown-trigger/nxt-dropdown-trigger.component';
import { NxtMatSearchComponent } from './components/nxt-mat-search/nxt-mat-search.component';
import { NxtOptionGroupComponent } from './components/nxt-dropdown/components/nxt-option-group/nxt-option-group.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { NxtOptionComponent } from './components/nxt-dropdown/components/nxt-option/nxt-option.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { NxtDemoComponent } from './components/nxt-demo/nxt-demo.component';
import { NxtPaginatorComponent } from './components/nxt-paginator/nxt-paginator.component';
import { NxtStringListOverflowMenuComponent } from './components/nxt-string-list-overflow-menu/nxt-string-list-overflow-menu.component';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';

@NgModule({
    declarations: [
      TooltipIfTruncatedDirective,
      HasPermissionDirective,
      NxtDropdownComponent,
      NxtDropdownLabelSuffixDirective,
      NxtDropdownTriggerComponent,
      NxtOptionComponent,
      NxtDemoComponent,
      NxtPaginatorComponent,
      NxtMatSearchComponent,
      NxtOptionGroupComponent,
      NxtStringListOverflowMenuComponent
    ],
    imports: [
      CommonModule,
      NgbTooltipModule,
      FormsModule,
      ReactiveFormsModule,
      MatFormFieldModule,
      MatInputModule,
      OverlayModule,
      MatMenuModule,
      MatTooltipModule
    ],
    exports: [
    TooltipIfTruncatedDirective,
    HasPermissionDirective,
    NxtDemoComponent,
    NxtDropdownComponent,
    NxtDropdownLabelSuffixDirective,
    NxtDropdownTriggerComponent,
    NxtOptionComponent,
    NxtOptionGroupComponent,
    NxtDropdownTriggerComponent,
    NxtMatSearchComponent,
    NxtStringListOverflowMenuComponent,
    OverlayModule
  ]
})
export class SharedModule { }
